import { useContext } from "react";
import { AuthCtx } from "./AuthCtx.ts";

export function useAuthCtx() {
  return useContext(AuthCtx);
}
